import { render, staticRenderFns } from "./bizAnswer.vue?vue&type=template&id=7ecedc36"
import script from "./bizAnswer.vue?vue&type=script&lang=js"
export * from "./bizAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports